var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71149 10.9802V13.3219C3.71149 13.9302 4.04482 14.4969 4.57816 14.7886L8.74482 17.0636C9.24482 17.3386 9.84482 17.3386 10.3448 17.0636L14.5115 14.7886C15.0448 14.4969 15.3782 13.9302 15.3782 13.3219V10.9802L10.3448 13.7302C9.84482 14.0052 9.24482 14.0052 8.74482 13.7302L3.71149 10.9802ZM8.74482 2.93022L1.71982 6.76356C1.14482 7.08022 1.14482 7.91356 1.71982 8.23022L8.74482 12.0636C9.24482 12.3386 9.84482 12.3386 10.3448 12.0636L17.0448 8.40522V13.3302C17.0448 13.7886 17.4198 14.1636 17.8782 14.1636C18.3365 14.1636 18.7115 13.7886 18.7115 13.3302V7.98856C18.7115 7.68022 18.5448 7.40522 18.2782 7.25522L10.3448 2.93022C9.84482 2.66356 9.24482 2.66356 8.74482 2.93022Z",
    fill: "#3964FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.607cbe3c1cda4f9fe744a766930f8141.svg";
export { ForwardRef as ReactComponent };